import React, { Component } from "react"
import Divider from "../Divider/Divider"

import "./Meet.css"
import meetTheChef from "../images/meet-the-chef.jpg"
import chefHat from "../images/chef-hat.svg"
import phone from "../images/support.svg"
import mail from "../images/mail.svg"

const Meet = () => (
  <div className="meet-the-chef">
    <div className="meet-the-chef__image-wrapper">
      <img
        alt="Andre Dealmeida"
        className="meet-the-chef__image"
        src={meetTheChef}
      />
      <div className="meet-the-chef__sub-text">
        Head Chef & Owner
        <span>Andy Dealmeida</span>
      </div>
      <div className="meet-the-chef__contact">
        <div className="meet-the-chef__icon-wrapper">
          <img
            alt="Contact Phone"
            className="meet-the-chef__contact-icon"
            src={phone}
          />
          <a href="tel:954-629-1046">954-629-1046</a>
        </div>

        <div className="meet-the-chef__icon-wrapper">
          <img
            alt="Contact Email"
            className="meet-the-chef__contact-icon"
            src={mail}
          />
          <a href="mailto:info@hibachiandyou.com">info@hibachiandyou.com</a>
        </div>
      </div>
    </div>
    <heading className="meet-the-chef__header">
      <img alt="Chef Hat" className="meet-the-chef__icon" src={chefHat} />
      <h1>Meet the Chef</h1>
      <Divider />
    </heading>

    <div className="meet-the-chef__bio">
      <p>
        Chef Andy Dealmeida has over <span>25 years of experience</span> in the
        Culinary Arts. He is a trained professional with a passion for cooking
        and catering.
      </p>
      <p>
        Andy started cooking professionally in 1992, when a chance job offer
        fell into his lap. Seeing a chance to pursue his passion, he took the
        job and hasn't looked back since. He worked for 10 years as a cook
        before becoming a Hibachi chef at a major restaurant in{" "}
        <span>Boca Raton Florida.</span>
      </p>

      <p>
        Andy now pursues his dream of catering and cooking for private parties;
        where he seeks to delight his guests with delicious hibachi cuisine and
        impeccable professional service.
      </p>
      <p>
        <span>"A good chef is a passionate chef." -Andy Dealmeida</span>
      </p>
    </div>
  </div>
)

export default Meet



// WEBPACK FOOTER //
// ./src/Meet/Meet.js